import { NextImage } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import { loaderGIF } from 'src/helpers/Constants';

const Loader = ({ className }: { className?: string }) => {
  return <NextImage className={className} field={loaderGIF} />;
};

export default Loader;
